module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Liesberg-d17e2342d18a5087db3796b05a8e0609.png";